import {
    GET_REGION_STATE_REPORT_BY_CUSTOMER_ERROR,
    GET_REGION_STATE_REPORT_BY_CUSTOMER_REQUEST,
    GET_REGION_STATE_REPORT_BY_CUSTOMER_SUCCESS,
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_REGION_STATE_REPORT_BY_CUSTOMER_REQUEST:
            return {
                loading: true,
            };
        case GET_REGION_STATE_REPORT_BY_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_REGION_STATE_REPORT_BY_CUSTOMER_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}